const defaultCart = {
  count : 0,
  items : [],
  description : "",
}
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state=defaultCart, action) =>{
  switch(action.type){
    case 'ADD_ITEMS':
      return {
        ...state,
        count : action.count + 1,
        items : state.items.concat(action.items),
      }

    case 'ADD_CAD':
      return{
        ...state,
        description : action.description,
      }

    case 'UPDATE_CART':
     return{
       count : action.count,
       items : action.items,
     }
    default:
      return state
  }
}
